import { useLocation } from 'react-router-dom'
import { useLanguageToggle, useT } from '../i18n'
// CSS Module — only contains the fixed-position container. The
// ``.glass-pill`` visual primitive stays global (see
// ``styles/glass-pill.css``); both LanguageSwitcher + ThemeSwitcher
// use it and ``themes.css`` writes overrides keyed on its name.
// See #264 PR C.
import s from './LanguageSwitcher.module.css'

/**
 * Small floating button that toggles between Korean (default) and
 * English by prefixing/unprefixing `/en` on the current path.
 *
 * On the splash screen the violet gradient is hardcoded irrespective
 * of theme, so the pill flips to a white-text glass variant
 * (`.glass-pill--on-dark`) to match the surrounding splash buttons +
 * floating bubbles. Everywhere else it uses the light-glass default
 * which reads on cream / paper backdrops.
 */
export default function LanguageSwitcher() {
  const toggle = useLanguageToggle()
  const t = useT()
  const location = useLocation()

  const isSplash =
    location.pathname === '/' || location.pathname === '/en'

  return (
    <button
      onClick={toggle}
      aria-label="Toggle language"
      className={[
        s.languageSwitcher,
        'glass-pill',
        isSplash && 'glass-pill--on-dark',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {t('lang.toggleLabel')}
    </button>
  )
}
